/**
 * getLeaderboard.js
 * Written by: Alex Kasemir
 */

import alertActions from 'store/alert/actions';
import request from '../../../request/actions';


export const GET_LEADERBOARD_START = `GET_LEADERBOARD_START`;
export const GET_LEADERBOARD_SUCCESS = `GET_LEADERBOARD_SUCCESS`;
export const GET_LEADERBOARD_FAILURE = `GET_LEADERBOARD_FAILURE`;

export const getLeaderboardStart = () => ({
  type: GET_LEADERBOARD_START,
});

export const getLeaderboardSuccess = (id, players) => ({
  type: GET_LEADERBOARD_SUCCESS,
  id,
  players,
});

export const getLeaderboardFailure = (error, id) => ({
  type: GET_LEADERBOARD_FAILURE,
  error,
  id,
});

/**
 * Description of the getLeaderboard action
 */
export const getLeaderboard = (id) => {
  return (dispatch) => {
    const count = id === `top100` ? 100 : null;
    const aroundme = id === `aroundme` ? `true` : null;
    const friends = id === `friends` ? `true` : null;
    return new Promise((resolve, reject) => {
      dispatch(request(`/leaderboard`, `GET`, null, { count, aroundme, friends }))
        .then((response) => {
          dispatch(getLeaderboardSuccess(id, response.data));
          resolve();
        })
        .catch((error) => {
          dispatch(alertActions.createAlert({
            message: `An unknown error occurred. Are you logged in?`,
            type: `danger`,
          }));
          dispatch(getLeaderboardFailure(error, id));
          reject();
        });
    });
  };
};

export default getLeaderboard;
